export const isLocalHost = () => {
  return process.env.REACT_APP_ENV === 'local'
    || (window && ['127.0.0.1', 'localhost'].includes(window.location.hostname));
};
